<!-- Print-only date stamp so printed pages show when they were printed -->
<template>
	<span
		class="hidden text-sm font-normal text-slate-500 normal-case not-italic print:inline"
	>
		{{ d(printedAt, 'longDate') }}
	</span>
</template>

<script setup lang="ts">
import { usePresentationLocale } from '@/i18n'
import { onBeforeUnmount, onMounted, ref } from 'vue'

const { d } = usePresentationLocale()

const printedAt = ref(new Date())

// Pages like the memorial guide slide can stay open for a long time before
// printing, so refresh the date right before the print dialog opens
const updatePrintedAt = () => {
	printedAt.value = new Date()
}

onMounted(() => window.addEventListener('beforeprint', updatePrintedAt))
onBeforeUnmount(() =>
	window.removeEventListener('beforeprint', updatePrintedAt)
)
</script>
